<template>
  <ModalBase :show-modal="showModal" @close-modal="close" full-h class="documents-modal">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:pretitle>
          {{ (isShareDocument) ? $gettext('SEND') : (isEditModal) ? $gettext('EDIT'): $gettext('ADD') }}
        </template>
        <template v-slot:title>
          <div v-show="!isShareDocument">
            <span v-if="!isEditModal" v-translate>New document</span>
            <span v-if="isEditModal">{{documentTitle}}</span>
          </div>
          <div v-show="isShareDocument">
            <span v-translate>Share your documents</span>
          </div>
        </template>
        <template v-slot:buttons>
          <div class="modal-action-bar">
            <GekkoButton 
              v-if="!isShareDocument && isEditModal"
              :text="$gettext('Delete')"
              icon="fa-solid fa-trash"
              class="text-danger"
              key="delete-btn"
              v-gk-confirm="{
                title: $gettext('Delete document'),
                message: $gettext('Are you sure you want to delete this document?'),
                options: {
                    variant: 'danger',
                    confirmText: $gettext('Delete')
                },
                callback: deleteDocument
              }"
            />
            <GekkoButton 
              v-if="!isShareDocument"
              @click="shareDocument()"
              key="share-btn"
              :text="$gettext('Share')"
              icon="fa-solid fa-share"
              class="text-info"/>
            <GekkoButton 
              v-if="isShareDocument"
              @click="addEdit()"
              key="edit-btn"
              :text="navButtonText"
              icon="fa-solid fa-pencil"
              class="text-info"/>
          </div>
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <AddEditDocument 
        v-if="!isShareDocument" 
        ref="addeditdocument" 
        @documentDetails="onDocumentDetails"
        @created="onDocumentCreated"
        @updated="onDocumentUpdated" />
      <ShareDocument 
        v-if="isShareDocument" 
        ref="sharedocument" />
    </template>
    <template v-slot:actions>
      <GekkoButton 
        v-if="!isShareDocument"
        @click="$refs.addeditdocument.saveForm()"
        :text="$gettext('Save Document')"
        icon="fa-solid fa-floppy-disk"
        type="submit"
        class="float-right position-relative"
        :loading="isWaitingForResponse"/>
      <GekkoButton 
        v-if="isShareDocument"
        @click="$refs.sharedocument.$refs['document-share-form'].requestSubmit()"
        :text="$gettext('Send')"
        icon="fa-solid fa-paper-plane"
        type="submit"
        class="float-right position-relative"
        :loading="isWaitingForResponse"/>
    </template>
  </ModalBase>
</template>

<script>
import { mapGetters } from 'vuex';
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import ModalBase from "@/components/base_components/ModalBase";
import AddEditDocument from "@/components/documents/AddEditDocument";
import DocumentService from "@/store/services/document.service";
import ShareDocument from "@/components/documents/ShareDocument";

export default {
    name: "DocumentsModal",
    components: { ModalBase, TitleBar, GekkoButton, AddEditDocument, ShareDocument},
    props: {
        showModalOn: {
            type: Array
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(to) {
                this.showModal = this.showModalOn.includes(to.name);
                (this.showModal) ? document.body.classList.add('modal-on') : document.body.classList.remove('modal-on');
            }
        },
    },
    data() {
        return {
            showModal: false,
            documentTitle: ""
        }
    },
    created() {
        window.addEventListener('keydown', this.closeEventListener);
    },
    destroyed () {
        window.removeEventListener('keydown', this.closeEventListener);
    },
    methods: {
        closeEventListener(event) {
            if (this.showModal && event.key === 'Escape') this.close();
        },
        close(){
            this.$router.push({name: 'Documents'});
        },
        onDocumentCreated(obj) {
            this.$emit('created', obj);
        },
        onDocumentUpdated(obj) {
            this.$emit('updated', obj);
        },
        deleteDocument () {
          DocumentService.delete(this.$route.params['documentId']).then(() => {
            this.$emit("deleted", this.$route.params['documentId']);
            this.$router.push({name: "Documents"});
            this.$store.commit('setAlert', {
              title: this.$gettext("Document deleted"),
              text: this.$gettext("The document was deleted from the list."),
              variant: "success",
              duration: 4
            });
          }).catch(() => {
            this.$store.commit('setAlert', {
              title: this.$gettext("Error"),
              text: this.$gettext("Error deleting the document."),
              variant: "danger",
              duration: 4
            });
          });
        },
        shareDocument () {
          if (this.isEditModal) {
            console.log(this.$route.params['documentId'])
            this.$router.push({ name: 'ShareDocument', params: { documentId: this.$route.params['documentId'] } });
          } else {
            this.$router.push({ name: 'ShareDocuments' });
          }
        },
        addEdit() {
          if (this.isEditModal) {
            this.$router.push({name: 'EditDocument', params: { documentId: this.$route.params['documentId'] } });
          } else {
            this.$router.push({ name: 'AddDocument' });
          }
        },
        onDocumentDetails(obj) {
          this.documentTitle = obj.title;
        }
    },
    computed: {
      ...mapGetters({
          isWaitingForResponse: 'main/isWaitingForResponse'
        }),
        isEditModal() {
          return this.$route.params['documentId'] != null;
        },
        isShareDocument() {
          return this.$route.name === 'ShareDocument' || this.$route.name === 'ShareDocuments'
        },
        navButtonText() {
          if (this.isShareDocument && !this.isEditModal)
            return this.$gettext('Add');
          return this.$gettext('Edit');
        }
    }
}
</script>

<style lang="scss">
  .documents-modal {
    .gk-modal {
      .gk-modal-label {
        margin-bottom: 0.5rem;
        font-size: 1rem;
      }
    }
  }
  @media (max-width: 575px) {
      .documents-modal {
          .gk-modal-content {
              overflow-y: scroll;
              overflow-x: hidden;
              .modal-content-wrap {
                  .os-host { height: auto !important; }
                  .modal-dropzone-actions { padding: 0; }
                  .cost-modal-actions {
                      .cost-complete-info-wrapper {
                          margin-bottom: 1rem;
                      }
                  }
              }
          }
      }
  }
</style>